import { render, staticRenderFns } from "./freeBox.vue?vue&type=template&id=c32f4e5c&scoped=true&"
import script from "./freeBox.vue?vue&type=script&lang=js&"
export * from "./freeBox.vue?vue&type=script&lang=js&"
import style0 from "./freeBox.vue?vue&type=style&index=0&id=c32f4e5c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32f4e5c",
  null
  
)

export default component.exports